import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import MasterAset from "./MasterAset";
import MasterBarang from "./MasterBarang";

const Dashboard = ({ user, setUser }) => {

  const [activeMenu, setActiveMenu] = useState(null);
  const [greeting, setGreeting] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userAccess, setUserAccess] = useState([]);

/* FORCE ROOT EVERYTIME */
useEffect(() => {
  const fixUrl = () => {
    if (window.location.pathname !== "/") {
      window.history.replaceState({}, "", "/");
    }
  };

  fixUrl();
  window.addEventListener("popstate", fixUrl);

  return () => window.removeEventListener("popstate", fixUrl);
}, []);

  /* =========================
     LOAD MENU FROM URL (refresh support)
  ==========================*/
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const menuFromUrl = params.get("menu");

    if (menuFromUrl) {
      setActiveMenu(menuFromUrl);
    }
  }, []);

  /* =========================
     SAVE MENU TO URL
  ==========================*/
  const handleSetActiveMenu = (menuKey) => {
    setActiveMenu(menuKey);
    setSidebarOpen(false);

    const newUrl = menuKey ? `/?menu=${menuKey}` : "/";
    window.history.pushState({}, "", newUrl);
  };

  /* =========================
     GET USER ACCESS
  ==========================*/
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser?.access) setUserAccess(storedUser.access);
  }, []);

  /* =========================
     RESPONSIVE
  ==========================*/
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
      if (window.innerWidth >= 992) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* =========================
     GREETING
  ==========================*/
  useEffect(() => {
    const updateGreeting = () => {
      const hour = new Date().getHours();

      if (hour >= 1 && hour <= 10) setGreeting("🌅 Selamat Pagi");
      else if (hour <= 15) setGreeting("🌤️ Selamat Siang");
      else if (hour <= 18) setGreeting("🌇 Selamat Sore");
      else setGreeting("🌙 Selamat Malam");
    };

    updateGreeting();
    const timer = setInterval(updateGreeting, 60000);
    return () => clearInterval(timer);
  }, []);

  /* =========================
     LOGOUT
  ==========================*/
  const handleLogout = () => {
    setUser(null);
    localStorage.clear();
    window.history.replaceState({}, "", "/");
  };

  const sidebarWidth = isMobile ? 220 : 280;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        background: "#f9fafb",
      }}
    >

      {/* ================= NAVBAR ================= */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 64,
          background: "#fff",
          zIndex: 1000,
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        }}
      >
        <Navbar
          user={user}
          onLogout={handleLogout}
          onSelectMenu={handleSetActiveMenu}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          onGoHome={() => handleSetActiveMenu(null)}
          isMobile={isMobile}
        />
      </div>

      {/* ================= BODY ================= */}
      <div
        style={{
          display: "flex",
          flex: 1,
          marginTop: 64,
          overflow: "hidden",
        }}
      >

        {/* SIDEBAR */}
        <Sidebar
          activeMenu={activeMenu}
          setActiveMenu={handleSetActiveMenu}
          visible={isMobile ? sidebarOpen : true}
          onClose={() => setSidebarOpen(false)}
          userAccess={userAccess}
        />

        {/* CONTENT */}
        <div
          style={{
            flex: 1,
            marginLeft: isMobile ? 0 : sidebarWidth,
            padding: 24,
            overflowY: "auto",
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={activeMenu || "home"}
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -40 }}
              transition={{ duration: 0.3 }}
            >

              {/* MENU UTAMA */}
              {!activeMenu && (
                <div style={{ fontSize: "1.2rem" }}>
                  Halo, {user?.name || "User"} 👋 — {greeting}
                </div>
              )}

              {/* MASTER ASET */}
              {activeMenu === "master-aset" && <MasterAset />}

              {/* MASTER BARANG */}
              {activeMenu === "master-barang" && (
                <MasterBarang userAccess={userAccess} />
              )}

              {activeMenu === "add-asset" && <div>-</div>}
              {activeMenu === "purchase-order" && <div></div>}
              {activeMenu === "permintaan-barang" && <div></div>}
              {activeMenu === "purchase-request" && <div></div>}
              {activeMenu === "pengajuan-rop" && <div></div>}

            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;